{
  "de": {
    "onboarding": {
      "steps": {
        "name": {
          "heading": "Wie lautet dein Name?",
          "headingInternational": "Willkommen an Board!",
          "paragraph": "Wir benötigen deinen richtigen Namen für die Teilnahmebescheinigungen.",
          "paragraphInternational": "Bitte lass uns deinen Namen wissen.",
          "submit": "Weiter"
        },
        "international": {
          "heading": "Für welche Angebote interessierst du dich?",
          "submit": "Weiter",
          "options": {
            "false": "Deutschsprachige Angebote 🇩🇪 🇦🇹 🇨🇭",
            "true": "Englischsprachige Angebote 🌎"
          },
          "descriptions": {
            "false": "Empfohlen für Personen, die Deutsch sprechen (größeres Angebot an Fortbildungen)",
            "true": "Empfohlen für Personen, die kein Deutsch sprechen"
          }
        },
        "job": {
          "heading": "Was beschreibt deine Rolle am besten?",
          "paragraph": "Ich bin...",
          "submit": "Weiter",
          "skip": "Später ausfüllen"
        },
        "company": {
          "heading": "Wo arbeitest du?",
          "submit": "Weiter",
          "pleaseSelect": "Bitte Bildungseinrichtung auswählen",
          "noResults": "Keine Ergebnisse. Bitte trage deine vollständige Postleitzahl ein."
        },
        "country": {
          "heading": "In welchem Land arbeitest du?",
          "paragraph": "Wir möchten dich mit dem besten Service für deine Sprache und dein Schulsystem unterstützen.",
          "submit": "Weiter"
        },
        "grade": {
          "heading": "Wo unterrichtest du?",
          "paragraph": "Wir haben für alle Altersstufen und Schulformen Fortbildungen und Webinare. Mit dieser Information hilfst du uns, dir die passenden Inhalte zu empfehlen.",
          "submit": "Weiter"
        },
        "region": {
          "heading": "Wo arbeitest du?",
          "paragraph": "Mit dieser Information hilfst du uns, dir Informationen & Angebote speziell für dein Bundesland zu empfehlen.",
          "submit": "Weiter"
        },
        "subject": {
          "heading": "Welche Schulfächer unterrichtest du?",
          "paragraph": "Wir haben für alle Altersstufen und Schulformen Fortbildungen und Webinare. Mit dieser Information hilfst du uns, dir die passenden Inhalte zu empfehlen.",
          "submit": "Weiter"
        },
        "tool": {
          "heading": "Wofür interessierst du dich am meisten?",
          "paragraph": "Mit diesen Präferenzen können wir dir die besten Empfehlungen geben.",
          "submit": "Weiter"
        },
        "infoFrom": {
          "heading": "Schön, dass du da bist!",
          "headingReOnboarding": "Das war's! Danke für deine Angaben.",
          "subHeading": "Deine Anmeldung war erfolgreich.",
          "paragraph": "Eine letzte Frage noch: Wie hast du von fobizz erfahren?",
          "submit": "Los geht's"
        }
      },
      "reOnboarding": {
        "heading": "Willkommen zurück bei fobizz!",
        "paragraph": "Damit wir dir passende Empfehlungen machen können, fragen wir in regelmäßigen Abständen, ob deine Angaben noch aktuell sind.",
        "thanks": "Danke, dass du dir kurz Zeit dafür nimmst!",
        "start": "Los geht's!",
        "skip": "Nicht jetzt"
      },
      "labels": {
        "back": "Zurück",
        "or": "oder",
        "skip": "Überspringen",
        "pleaseSpecify": "Bitte genauer angeben",
        "companyKind": "Bildungseinrichtung",
        "schoolType": "Schultyp",
        "country": "Land",
        "zipcode": "Postleitzahl",
        "newCompany": "Meine Bildungseinrichtung ist nicht dabei",
        "companyName": "Name der Bildungseinrichtung (Bitte ausschreiben, keine Abkürzung)",
        "customSchoolType": "Sonstiger Schultyp",
        "customCompany": "In welcher Einrichtung bist du tätig?",
        "street": "Straße, Hausnummer",
        "city": "Stadt",
        "searching": "Suche ...",
        "activate": "Aktivieren"
      },
      "enums": {
        "infoFromType": {
          "school_administration": "Schulleitung",
          "colleagues": "Kollegium",
          "instagram": "Instagram",
          "twitter": "Twitter",
          "facebook": "Facebook",
          "pinterest": "Pinterest",
          "linkedin": "LinkedIn",
          "online_search": "Suche im Internet",
          "ai_assistant": "KI-Assistent",
          "social_media": "Social Media",
          "custom": "Sonstiges"
        },
        "regionCode": {
          "BW": "Baden-Württemberg",
          "BY": "Bayern",
          "BE": "Berlin",
          "BB": "Brandenburg",
          "HB": "Bremen",
          "HH": "Hamburg",
          "HE": "Hessen",
          "MV": "Mecklenburg-Vorpommern",
          "NI": "Niedersachsen",
          "NW": "Nordrhein-Westfalen",
          "RP": "Rheinland-Pfalz",
          "SL": "Saarland",
          "SN": "Sachsen",
          "ST": "Sachsen-Anhalt",
          "SH": "Schleswig-Holstein",
          "TH": "Thüringen"
        },
        "toolsByValue": {
          "1": "KI Tools",
          "2": "Unterrichtsmaterialien entdecken",
          "3": "Online Weiterbildungen",
          "4": "KI Tools für Schüler*innen",
          "5": "Eigenes digitales Material erstellen"
        }
      }
    }
  }
}
